import { createApp } from 'vue';
import App from './App.vue';
import router from "@/router/router";

// import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';


/**
 * The `app` variable represents the root instance of a Vue.js application.
 * It is created using the `createApp` function, which initializes the application
 * with the specified root component.
 *
 * This instance serves as the central point for configuring and managing the application,
 * including registering components, plugins, directives, and other application-level options.
 *
 * @type {Object}
 */
const app = createApp(App)

app.use(VueSweetalert2);

app.use(router).mount('#app');


// todo añadir vue-router a la documentación

//todo Usar mensajes de error de la API
